export default __webpack_public_path__ + "static/media/uses.93a4c48c.png";